import * as React from "react";

export const Post = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.0157 3.44388C1.64005 2.50475 2.62428 1.59914 3.52896 2.05148L13.4583 7.01614C14.269 7.42151 14.269 8.5785 13.4583 8.98388L3.52896 13.9485C2.62427 14.4009 1.64005 13.4953 2.0157 12.5561L3.32729 9.27717C3.45036 8.9695 3.79954 8.81985 4.10721 8.94292C4.41488 9.06599 4.56453 9.41517 4.44146 9.72284L3.22756 12.7576L12.7427 8.00001L3.22756 3.24242L4.35349 6.05726L7.33903 7.45673C7.63908 7.59738 7.76829 7.95462 7.62765 8.25467C7.487 8.55471 7.12976 8.68393 6.82971 8.54328L3.80843 7.12706C3.5558 7.00863 3.35761 6.79864 3.25398 6.53958L2.0157 3.44388Z"
    />
);
